import { render } from "./ConflictLogs.vue?vue&type=template&id=5b33238a&scoped=true"
import script from "./ConflictLogs.vue?vue&type=script&lang=js"
export * from "./ConflictLogs.vue?vue&type=script&lang=js"

import "./ConflictLogs.vue?vue&type=style&index=0&id=5b33238a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b33238a"]])

export default __exports__